import React from 'react';
import Parcel from 'single-spa-react/lib/esm/parcel';
import { mountRootParcel } from 'single-spa';
import { compose } from 'recompose';
import Cookies from 'js-cookie';
import { passApplication } from '@unitedtraders/application-bootstrapper';
import { translate } from '../../utils/translateUtils';
import { getDomain } from '../../utils/domain';

const enhance = compose(translate, passApplication);

const goTo = href => {
  window.location.href = href;
};

const SideMenuView = enhance(
  ({ application: { settings, authorization, history }, lng, ...props }) => {
    const appConfig = {
      graphqlGateway: settings.get('utcomGateway'),
      utFeed: settings.get('utFeed'),
      utPassport: settings.get('utPassport')
    };

    const push = pathname => {
      history.push(
        `${window.location.pathname}/${pathname}`.replace(/\/{2,}/g, '/').replace(/\/$/, '')
      );
    };

    const sideMenuProps = {
      appConfig,
      featureFlags: {},
      getTokens: () => authorization.getTokens(),
      isAuthorized: authorization.isAuthenticated(),
      locale: lng,
      navigateTo: goTo,
      onLogin: () => push('/auth/login'),
      onLogout: () => authorization.logout(),
      onRegistration: () => push('/auth/registration'),
      setLocale,
      toDeposit: () => push('/deposit'),
      openDepositModal: () => push('/deposit'),
      openWithdrawModal: () => push('/withdraw'),
      loginWith2FARecomendation: {
        isVisible: false,
        hide: () => null
      }
    };

    return (
      <div className="sidemenu-external">
        <Parcel
          config={() => import('@unitedtraders/side-menu-microfrontend')}
          mountParcel={mountRootParcel}
          {...sideMenuProps}
          {...props}
        />
      </div>
    );
  }
);

export const SideMenu = enhance(SideMenuView);

function setLocale(lng) {
  Cookies.set('locale', lng, {
    expires: 365 * 2,
    domain: getDomain()
  });
  window.location.reload();
}



// WEBPACK FOOTER //
// ./src/components/SideMenu/index.jsx